/** @type {import('../help-index.js').HelpSidebarItem} */
export const FIN_CRC_CONFIG_ITEM = {
  id: 'config',
  screenId: 'fin-crc-config',
  label: 'Configuración',
  description: 'Marcas, procesadoras, terminales POS y marcas por terminal.',
  detail: {
    sections: [
      {
        title: 'Para qué sirve',
        intro:
          'Antes de operar cupones, control y liquidaciones, configurá quién procesa las tarjetas, qué marcas aceptás en cada terminal y en qué cuenta bancaria se depositan los cobros.',
      },
      {
        title: 'Orden recomendado',
        bullets: [
          '1. Marcas — Visa, Mastercard, Cabal, etc.',
          '2. Proveedores — procesadoras (Prisma, Fiserv, Mercado Pago tarjeta, etc.).',
          '3. Terminales — cada punto de venta físico o virtual.',
          '4. Marcas por POS — qué marcas acepta cada terminal.',
        ],
      },
      {
        title: 'Pestaña Marcas',
        bullets: [
          'Lista: ID, Descripción, Activo.',
          'Botón + crea una marca con solo «Descripción» (obligatoria).',
          'Tocá una fila para ver detalle. No hay edición desde la grilla.',
        ],
      },
      {
        title: 'Pestaña Proveedores',
        bullets: [
          'Lista: ID, Descripción, Activo.',
          'Botón + crea un proveedor con «Descripción» (nombre de la procesadora).',
          'Tocá una fila para consultar.',
        ],
      },
      {
        title: 'Pestaña Terminales',
        intro: 'Cada terminal POS vincula procesadora, cuenta de depósito y opcionalmente número de terminal.',
        fields: [
          { label: 'Descripción', description: 'Nombre interno (por ejemplo «POS mostrador»). Obligatorio.' },
          { label: 'Cuenta depósito', description: 'Cuenta bancaria donde se acreditan los cobros de este terminal. Debe existir en Finanzas → Bancos.' },
          { label: 'Proveedor', description: 'Procesadora que liquida este terminal.' },
          { label: 'Número de terminal', description: 'Opcional. Identificador del equipo ante la procesadora.' },
        ],
        paragraphs: [
          'Lista: ID, Descripción, Proveedor, Cuenta depósito, Moneda, Nº terminal, Activo.',
          'Solo ves terminales a los que tenés acceso. Quien crea un terminal queda autorizado.',
        ],
      },
      {
        title: 'Pestaña Marcas por POS',
        intro: 'Indicá qué marcas de tarjeta puede cobrar cada terminal.',
        bullets: [
          'Elegí el terminal en el selector superior.',
          'La lista muestra las marcas ya vinculadas a ese POS.',
          'Botón + agrega una marca al terminal seleccionado.',
          'Papelera quita la relación marca–terminal.',
        ],
        paragraphs: [
          'Sin marcas vinculadas al POS, el cobro con tarjeta en ese terminal puede fallar o no clasificarse bien.',
        ],
      },
    ],
  },
}
